export enum SheetType {
  DEC = 'DEC',
  FORFAIT = 'FORFAIT',
  PEP = 'PEP',
  DED = 'DED',
  FDES = 'FDES',
  USERS = 'users',
  FE = 'FE',
  FC = 'FC',
  BUNDLE = 'bundle',
  REFURBISHED = 'REFURBISHED',
  CUSTOM_USER = 'custom_user',
  EMPTY = 'EMPTY',
  EXTRAPOLE = 'EXTRAPOLE',
  EMPTY_COMPONENT = 'Composant vide', // This type is used for a SINGLE Sheet that is the RE2020 offcial empty component
  REFURBISHED_COMPONENT = 'Composant réemploi', // This type is used for a SINGLE Sheet that is the RE2020 offcial refurbished component
  EMPTY_REFURBISHED = 'EMPTY_REFURBISHED'
}
